import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Pencil = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M16.6213 6.20705L17.7929 7.37862L19.1716 5.99994L18 4.82837L16.5858 3.41416C17.3668 2.63311 18.6332 2.63311 19.4142 3.41416L20.5858 4.58573C21.3668 5.36678 21.3668 6.63311 20.5858 7.41416L11 16.9999H7V12.9999L16.5858 3.41416L18 4.82837L16.6213 6.20705ZM9 13.8284V14.9999H10.1716L16.3787 8.79284L15.2071 7.62126L9 13.8284Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      d="M12 3.99994H5C3.89543 3.99994 3 4.89537 3 5.99994V18.9999C3 20.1045 3.89543 20.9999 5 20.9999H17C18.1046 20.9999 19 20.1045 19 18.9999V12.9999H17V18.9999H5V5.99994H12V3.99994Z"
      fill="currentColor"
    />
  </Icon>
));

export default Pencil;
